/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { Brand } from '../model/brand';
import { BrandDetails } from '../model/brandDetails';
import { BrandList } from '../model/brandList';
import { CreateBrand } from '../model/createBrand';
import { DetachUserDetachUser } from '../model/detachUserDetachUser';
import { UpdateBrand } from '../model/updateBrand';
import { UsersAtachedToBrandList } from '../model/usersAtachedToBrandList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BackofficeBrandsService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Szczegóły Marki
     *  - __Path__: /backoffice/brands/{id} - __OperationName__: Query - __OutputModelName__: BrandDetails - __Entity__: SalesMailer\\Domain\\Brand - __Type__: doctrine - __OperationId__: BrandDetailsQuery - __Name__:  - __Method__: GET - __Description__:  - __Summary__: Szczegóły Marki - __RouteName__: GETBrandDetailsQuery - __Hash__: d44ac8e6ac83cbd4e66863f6333988f8 - __Input__:  - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__:  - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public brandDetailsQuery(id: string, observe?: 'body', reportProgress?: boolean): Observable<BrandDetails>;
    public brandDetailsQuery(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandDetails>>;
    public brandDetailsQuery(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandDetails>>;
    public brandDetailsQuery(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling brandDetailsQuery.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BrandDetails>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\Brand - __OperationId__: BrandListQuery - __OperationName__: ListQuery - __OutputModelName__: BrandListItem - __ListModelName__: BrandList - __DefaultSortOrder__:  - __Name__:  - __Path__: /backoffice/brands - __Method__: GET - __Description__:  - __Summary__:  - __RouteName__: GETBrandListItemListQuery - __Hash__: de9297586bc16dfb84280fd0000d2861 - __Input__:  - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__: list - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param page Numer strony (default: 1)
     * @param count Liczba wierszy na stronie (default: 25)
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param isArchived  (boolean, exact)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public brandListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BrandList>;
    public brandListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandList>>;
    public brandListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandList>>;
    public brandListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }
        if (isArchived !== undefined && isArchived !== null) {
            queryParameters = queryParameters.set('isArchived', <any>isArchived);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BrandList>(`${this.basePath}/api/backoffice/brands`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dodawanie Marki
     *  - __InputModelName__: CreateBrand - __InputParser__: serializer - __OperationName__: Handler - __OperationId__: CreateBrandHandler - __Name__:  - __Path__: /backoffice/brands - __Method__: POST - __Description__:  - __Summary__: Dodawanie Marki - __RouteName__: POSTBrandHandler - __Hash__: 8e12ee247cdd321ce13807b9d9ff8278 - __Input__: SalesMailer\\Application\\Brand\\CreateBrand - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__: Brand - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createBrandHandler(content?: CreateBrand, observe?: 'body', reportProgress?: boolean): Observable<Brand>;
    public createBrandHandler(content?: CreateBrand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Brand>>;
    public createBrandHandler(content?: CreateBrand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Brand>>;
    public createBrandHandler(content?: CreateBrand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Brand>(`${this.basePath}/api/backoffice/brands`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Usunięcie wybranej marki
     *  - __InputModelName__: DeleteBrand - __Path__: /backoffice/brands/{id} - __IsDeletableMethodName__: isDeletable - __TarEntity__:  - __EntityId__:  - __OperationName__: Handler - __OperationId__: DeleteBrandHandler - __Name__:  - __Method__: DELETE - __Description__:  - __Summary__: Usunięcie wybranej marki - __RouteName__: DELETEHandler - __Hash__: 2e4ac1e39484c8fe7629a5dba77e6c1f - __Input__: SalesMailer\\Domain\\Brand - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteBrandHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteBrandHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteBrandHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteBrandHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteBrandHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Odłączenie użytkownika od marki
     *  - __OperationName__: Handler - __OperationId__: DetachUserCommand - __Name__:  - __Path__: /backoffice/brands/user/detach-from-brand - __Method__: POST - __Description__:  - __Summary__: Odłączenie użytkownika od marki - __RouteName__: POSTHandler - __Hash__: b3144ed31f35337606d77ec978bbd3b4 - __Input__: SalesMailer\\Application\\Brand\\DetachUser - __Output__:  - __InputGroups__: detachUser - __OutputGroups__:  - __OutputModelName__:  - __InputModelName__: DetachUserDetachUser - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public detachUserCommand(content?: DetachUserDetachUser, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public detachUserCommand(content?: DetachUserDetachUser, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public detachUserCommand(content?: DetachUserDetachUser, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public detachUserCommand(content?: DetachUserDetachUser, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/backoffice/brands/user/detach-from-brand`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: archive - __Path__: /backoffice/brands/{id}/archive - __InputModelName__: UpdateBrand - __OperationName__: ArchiveBrandHandler - __OperationId__: UpdateBrandArchiveBrandHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTBrandListArchiveBrandHandler - __Hash__: 47f57ed4f0fc11c8c0cb2e79dd0ad6be - __Input__: SalesMailer\\Domain\\Brand - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__: list - __OutputModelName__: BrandList - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBrandArchiveBrandHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<BrandList>;
    public updateBrandArchiveBrandHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandList>>;
    public updateBrandArchiveBrandHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandList>>;
    public updateBrandArchiveBrandHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateBrandArchiveBrandHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<BrandList>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(id))}/archive`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edycja Marki
     *  - __InputParser__: serializer - __UpdateMethodName__: update - __Path__: /backoffice/brands/{id} - __InputModelName__: UpdateBrand - __OperationName__: Handler - __OperationId__: UpdateBrandHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__: Edycja Marki - __RouteName__: PUTBrandHandler - __Hash__: 172d0891e1368d2d1db02933acba4643 - __Input__: SalesMailer\\Application\\Brand\\UpdateBrand - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__: Brand - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBrandHandler(id: string, content?: UpdateBrand, observe?: 'body', reportProgress?: boolean): Observable<Brand>;
    public updateBrandHandler(id: string, content?: UpdateBrand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Brand>>;
    public updateBrandHandler(id: string, content?: UpdateBrand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Brand>>;
    public updateBrandHandler(id: string, content?: UpdateBrand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateBrandHandler.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Brand>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(id))}`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: unArchive - __Path__: /backoffice/brands/{id}/unarchive - __InputModelName__: UpdateBrand - __OperationName__: UnArchiveBrandHandler - __OperationId__: UpdateBrandUnArchiveBrandHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTBrandListUnArchiveBrandHandler - __Hash__: 8996667a76a9a0b723c82dc804131d13 - __Input__: SalesMailer\\Domain\\Brand - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__: list - __OutputModelName__: BrandList - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBrandUnArchiveBrandHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<BrandList>;
    public updateBrandUnArchiveBrandHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandList>>;
    public updateBrandUnArchiveBrandHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandList>>;
    public updateBrandUnArchiveBrandHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateBrandUnArchiveBrandHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<BrandList>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(id))}/unarchive`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista użytkowników przypisanych do marki
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\Account - __OperationId__: UsersAssignedToBrandListQuery - __OperationName__: ListQuery - __OutputModelName__: UsersAtachedToBrandListItem - __ListModelName__: UsersAtachedToBrandList - __DefaultSortOrder__: name - __Name__:  - __Path__: /backoffice/brands/{brandId}/brand-users - __Method__: GET - __Description__:  - __Summary__: Lista użytkowników przypisanych do marki - __RouteName__: GETUsersAtachedToBrandListItemListQuery - __Hash__: 31f804c9684a90cd1fe25cbf8c2016fa - __Input__:  - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: brandUsers - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param brandId 
     * @param page Numer strony (default: 1)
     * @param count Liczba wierszy na stronie (default: 25)
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersAssignedToBrandListQuery(brandId: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean): Observable<UsersAtachedToBrandList>;
    public usersAssignedToBrandListQuery(brandId: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UsersAtachedToBrandList>>;
    public usersAssignedToBrandListQuery(brandId: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UsersAtachedToBrandList>>;
    public usersAssignedToBrandListQuery(brandId: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (brandId === null || brandId === undefined) {
            throw new Error('Required parameter brandId was null or undefined when calling usersAssignedToBrandListQuery.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UsersAtachedToBrandList>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(brandId))}/brand-users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
